class PaymentHighlight extends HTMLElement {
  connectedCallback() {
    this.minAmount = parseInt(this.dataset.minAmount, 10) || 0;

    // The variant switch only re-renders a few targeted ids, so eligibility
    // has to follow the selected variant's price on its own.
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

    this.sectionId = this.closest("product-info")?.dataset?.section;

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      if (this.sectionId && sectionId && this.sectionId !== sectionId) return;

      // The section fetch already rendered the line for the new variant,
      // instalment amount included - reuse it rather than formatting money here.
      const source = event?.data?.html?.querySelector?.("payment-highlight");

      if (source) {
        const text = source.querySelector("span")?.textContent;
        const span = this.querySelector("span");
        if (text != null && span) span.textContent = text;

        this.classList.toggle(
          "payment-highlight-hidden",
          source.classList.contains("payment-highlight-hidden")
        );
        return;
      }

      const variant = event?.data?.variant;
      const eligible = Boolean(variant) && Number(variant.price) >= this.minAmount;

      this.classList.toggle("payment-highlight-hidden", !eligible);
    });
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }
}

customElements.define("payment-highlight", PaymentHighlight);
